import {get} from './walletAxios';
import {Game} from "../app/types/game";

export const GAME_PATH = '/api/game';

export const getGame = async (id: number): Promise<Game> => {
    return get(`${GAME_PATH}/${id}`).then(response => response ?? {});
};
